import React from 'react';

import ExportUserButton from '../../controls/maintenance/user/ExportUserButton';

const UserExportSection = (props) => {
  return <ExportUserButton />;
};

export default UserExportSection;
